<template>
  <div class="vx-card mt-5 mb-5" style="margin-bottom: 15px;">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center; margin-bottom: 33px;">
      <label style="margin-top: 12px !important;">NİTRO İSTATİSTİKİ BİLGİLER </label>
    </div>

    <template v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '9') != null">
      <div class="mt-5 mb-5" style="width:100%;   ">
        <div class="vx-row mb-5" style="margin-left:5px ;justify-content:center;">
          <label> <b style="color:red; font-size: 15px;"> Tarih </b></label>
        </div>

        <div class="vx-row  w-full" style=";justify-content:center;">
          <template v-if="1 == 2">
            <div class="vx-col" style="width:90px">
              <label style="justify-content:center">{{ "$" }}</label>

              <vs-input type="number" style="width:80px;" v-model="searchModel.currencyValueUsd" />
            </div>
            <div class="vx-col" style="width:90px">
              <label style="justify-content:center">{{ "€" }}</label>

              <vs-input type="number" style="width:80px;" v-model="searchModel.currencyValueEuro" />
            </div>
            <div class="vx-col" style="width:90px">
              <label style="justify-content:center">{{ "¥" }}</label>

              <vs-input type="number" style="width:80px;" v-model="searchModel.currencyValueYuan" />
            </div>
          </template>
          <input type="date" class="ml-4 mr-6 mt-4" v-model="searchModel.startTransactionDate" style="height:30px; " /><input type="date" class="mr-6 mt-4" style="height:30px; " v-model="searchModel.finishTransactionDate" />
          <feather-icon icon="RefreshCwIcon" style="transform: scale(2) translate(11%, 5%);" title="Yenile" svgClasses="ml-12 h-5 mr-5 hover:text-danger cursor-pointer" @click="GetCases()" />
        </div>
      </div>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO EN ÇOK SATIŞ YAPAN (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(saleForRegionDashboardPersonnelConsoliadtedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleForRegionDashboardPersonnelConsoliadtedTLList" class>İndir</JsonExcel>
            </div>
            <!-- -- style="cursor: pointer; width: 165px; color: green; font-weight: bold; font-size: 1.2rem;" -->
            <vs-table search :maxItems="10" :pagination="true" :data="saleForRegionDashboardPersonnelConsoliadtedTLList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amountTL }}
                  </vs-td>

                  <td class="flex">
                    <a
                      :href="'/AccountMovementConsolidatedPersonnelWatch/' + tr.userId + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;"
                      target="_blank"
                      ><b>Hareket</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- GRAFİK GÖSTERİMİ -->
        <div class="vx-col md:w-3/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO EN ÇOK SATIŞ YAPAN (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(saleForRegionDashboardPersonnelConsoliadtedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedPersonnelWatch" :series="seriesConsolidatedPersonnelWatch"></apexchart>
          </div>
        </div>

        <!-- TL BAZINDA BÖLGE SATIŞLARI CONSOLIDATED -->
        <div class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BÖLGE BAZLI SATIŞ (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(saleForRegionDashboardConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleForRegionDashboardConsolidatedTLList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="saleForRegionDashboardConsolidatedTLList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">Hesap Hareketleri</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amountTL }}
                  </vs-td>

                  <td class="flex">
                    <a
                      :href="'/AccountMovementSaleForRegionDashboardConsolidatedTL/' + tr.regionId + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;"
                      target="_blank"
                      ><b>Hareket</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- NİTRO BÖLGE BAZLI SATIŞ TL GRAFİK GÖSTERİMİ -->
        <div class="vx-col md:w-3/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BÖLGE BAZLI SATIŞ (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(saleForRegionDashboardConsolidatedTLList) }} {{ " TL" }}</b>
          </div>

          <div>
            <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedRegionWatch" :series="seriesConsolidatedRegionWatch"></apexchart>
          </div>
        </div>

        <!-- MARKA BAZINDA SATIŞLAR CONSOLIDATED -->
        <!-- Bu kısımda iki adet tutar alanı var birisi satış fiyatı diğer maliyet fiyatı -->
        <div class="vx-col md:w-3/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>MARKA BAZLI SATIŞ (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;white-space: nowrap;">
            <b> <span style="color:#0096FF"> Kâr : </span> {{ sumOfSalePriceTL }} {{ " ₺" }}</b>

            <b> {{ "- " + sumOfOwningCostTL }} {{ " ₺" }}</b>
            <b> {{ " = " + (sumOfSalePriceTL - sumOfOwningCostTL).toFixed(2) }} {{ " ₺" }}</b>

            <b> <span style="color:#0096FF"> Kâr Oranı : % </span> {{ (((sumOfSalePriceTL - sumOfOwningCostTL).toFixed(2) * 100) / sumOfOwningCostTL).toFixed(2) }}</b>
            <b> <span style="color:#0096FF"> Kâr Marjı : % </span> {{ (((sumOfSalePriceTL - sumOfOwningCostTL).toFixed(2) * 100) / sumOfSalePriceTL).toFixed(2) }}</b>
          </div>
          <div class="vx-col md:w-3/3 w-full">
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleBrandConsolidatedTLList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="saleBrandConsolidatedTLList">
              <template slot="thead">
                <vs-th>Adı</vs-th>
                <vs-th>Satış</vs-th>
                <vs-th>Maliyet</vs-th>
                <vs-th>Kâr</vs-th>
                <vs-th style="white-space: nowrap;">Kâr Oranı</vs-th>
                <vs-th style="white-space: nowrap;">Kâr Marjı</vs-th>
                <vs-th>Satış(₺)</vs-th>
                <vs-th>Maliyet(₺)</vs-th>
                <vs-th>Kâr(₺)</vs-th>
                <vs-th>İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 23) }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.convertToOwningCurrencySalePrice + " " + tr.owningCostCurrencyName }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.owningCostCurrencyName }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ (tr.convertToOwningCurrencySalePrice - tr.amount).toFixed(2) + " " + tr.owningCostCurrencyName }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ "% " + (((tr.convertToOwningCurrencySalePrice - tr.amount).toFixed(2) * 100) / tr.amount).toFixed(2) }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ "% " + (((tr.convertToOwningCurrencySalePrice - tr.amount).toFixed(2) * 100) / tr.convertToOwningCurrencySalePrice).toFixed(2) }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amountTL + " ₺" }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.owningCostTL + " ₺" }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ (tr.amountTL - tr.owningCostTL).toFixed(2) + " " + " ₺" }}
                  </vs-td>
                  <td class="flex">
                    <a
                      :href="'/AccountMovementSaleForBrandStatisticalDashboardConsolidatedTL/' + tr.accountDescription + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="color:  #7393B3 ;"
                      target="_blank"
                      ><b>Hareket</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- GRAFİK GÖSTERİMİ -->
        <div class="vx-col md:w-3/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>MARKA BAZLI SATIŞ (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(saleBrandConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedBrand" :series="seriesConsolidatedBrandWatch"></apexchart>
          </div>
        </div>
        <!-- ProductId Bazında Satış --><!-- ProductId Bazında Satış --><!-- ProductId Bazında Satış --><!-- ProductId Bazında Satış -->
        <vs-prompt
          style="z-index: 100001;"
          :vs-title="selectedBrand.brand + ' markalı ürünlerin satış dağılımları'"
          vs-accept-text="Kaydet"
          vs-cancel-text="Kapat"
          vs-button-cancel="border"
          :vs-active.sync="popupProductBase"
          :vs-buttons-hidden="true"
          @vs-cancel="popupProductBase = false"
        >
          <div class="vx-row w-full">
            <!-- GRAFİK GÖSTERİMİ -->
            <div class="vx-col md:w-4/4 w-full">
              <div>
                <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedProductBase" :series="seriesConsolidatedProductBaseWatch"></apexchart>
              </div>
            </div>
          </div>
        </vs-prompt>
        <!-- ProductId Bazında Satış END --><!-- ProductId Bazında Satış END --><!-- ProductId Bazında Satış END --><!-- ProductId Bazında Satış END --><!-- ProductId Bazında Satış END -->

        <!--END END END END MARKA BAZINDA SATIŞLAR CONSOLIDATED -->
        <!-- Bu kısımda iki adet tutar alanı var birisi satış fiyatı diğer maliyet fiyatı -->

        <!--START EXPENSE BAZINDA SATIŞLAR CONSOLIDATED -->
        <div class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO HARCAMALARI (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(expenseConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="expenseConsolidatedTLList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="expenseConsolidatedTLList">
              <template slot="thead">
                <vs-th class="w-1/3">Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amountTL }}
                  </vs-td>
                  <td class="flex">
                    <a
                      :href="'/AccountMovementForExpenseStatisticalDashboardConsolidatedTL/' + tr.accountCompanyTypeId + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="color:  #7393B3 ;"
                      target="_blank"
                      ><b>Hareket</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- GRAFİK GÖSTERİMİ -->
        <div class="vx-col md:w-3/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO HARCAMALARI (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(expenseConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedExpense" :series="seriesConsolidatedExpenseWatch"></apexchart>
          </div>
        </div>
        <!--END END END END EXPENSE BAZINDA SATIŞLAR CONSOLIDATED -->

        <!--START KİŞİ - TAHSİLAT BAZINDA TOPLAMLAR CONSOLIDATED -->
        <div class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO TAHSİLATLARI (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(customerPaymentConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="customerPaymentConsolidatedTLList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="customerPaymentConsolidatedTLList">
              <template slot="thead">
                <vs-th class="w-1/3">Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amountTL }}
                  </vs-td>
                  <td class="flex">
                    <a :href="'/AccountMovementForCustomerPaymentStatisticalDashboardConsolidatedTL/' + tr.userId + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate" style="color:  #7393B3 ;" target="_blank"
                      ><b>Hareket</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- GRAFİK GÖSTERİMİ -->
        <div class="vx-col md:w-3/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO TAHSİLATLARI (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(customerPaymentConsolidatedTLList) }} {{ " TL" }}</b>
          </div>
          <div>
            <apexchart width="100%" height="500px" type="bar" :options="chartOptionsConsolidatedCustomerPayment" :series="seriesConsolidatedCustomerPaymentWatch"></apexchart>
          </div>
        </div>
        <!--END END END END KİŞİ - TAHSİLAT BAZINDA TOPLAMLAR CONSOLIDATED -->

        <!-- ÜRÜN MALİYET RAPORU -->
        <!-- Bu kısımda 4 adet tutar alanı -->
        <div class="vx-col md:w-2/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>ÜRÜN MALİYET RAPORU (TL CONSOLIDATE)</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfStockOwningCost(costReportOfStockList) }} {{ " TL " }} - {{ getSumOfStockSalePrice(costReportOfStockList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="costReportOfStockList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="costReportOfStockList">
              <template slot="thead">
                <vs-th>Adı</vs-th>
                <vs-th>Birim Maliyet</vs-th>
                <vs-th>Toplam Maliyet</vs-th>
                <vs-th>Birim Satış</vs-th>
                <vs-th>Toplam Satış</vs-th>

                <vs-th>Toplam Maliyet TL</vs-th>
                <vs-th>Toplam Satış TL</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.productId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.productName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.owningCost + " " + tr.owningCostCurrencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.totalOwningCost + " " + tr.owningCostCurrencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.salePrice + " " + tr.salePriceCurrencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.totalSalePrice + " " + tr.salePriceCurrencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.totalOwningCostTL + " " + tr.tlLogo }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.totalSalePriceTL + " " + tr.tlLogo }}
                  </vs-td>
                  <td class="flex">
                    <a
                      :href="'/AccountMovementForExpenseStatisticalDashboardConsolidatedTL/' + tr.accountCompanyTypeId + '/' + -1 + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="color:  #7393B3 ;"
                      target="_blank"
                      ><b>.</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div v-if="1 == 2" class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-3/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO GÜN BAZLI SATIŞ GRAFİĞİ</b></label>
          </div>
          <div>
            <apexchart width="100%" height="500px" type="line" :options="chartOptions" :series="series"></apexchart>
          </div>
        </div>
      </div>

      <!-- Bu Div Şimdilik kapandı -->
      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <!-- Şimdilik kapandı -->
        <div class="vx-col md:w-1/4 w-full" v-if="1 == 2">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BÖLGE DIŞI SATIŞ</b></label>
          </div>

          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleForOutOfRegionList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="saleForOutOfRegionList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">Hesap Hareketleri</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/ConsolidatedOutofRegionWatch/' + tr.regionId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Link</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- NİTRO BÖLGE BAZLI SATIŞ -->
        <div class="vx-col md:w-1/4 w-full" v-if="1 == 2">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BÖLGE BAZLI SATIŞ</b></label>
          </div>

          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleForRegionList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="saleForRegionList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">Hesap Hareketleri</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a
                      :href="'/AccountMovementConsolidatedRegionWatch/' + tr.regionId + '/' + tr.currencyId + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;"
                      target="_blank"
                      ><b>Link</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- NİTRO EN ÇOK SATIŞ YAPAN -->
        <div v-if="1 == 2" class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO EN ÇOK SATIŞ YAPAN</b></label>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="saleForRegionPersonnelList" class>İndir</JsonExcel>
            </div>
            <vs-table search :maxItems="10" :pagination="true" :data="saleForRegionPersonnelList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">Hesap Hareketleri</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a
                      :href="'/AccountMovementConsolidatedPersonnelWatch/' + tr.userId + '/' + tr.currencyId + '/' + searchModel.startTransactionDate + '/' + searchModel.finishTransactionDate"
                      style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;"
                      target="_blank"
                      ><b>Link</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import apexchart from "vue-apexcharts";
import ApexCharts from "apexcharts/dist/apexcharts.common";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    apexchart,
    JsonExcel,
    ApexCharts,
  },
  data() {
    return {
      moneyCurrencyOptions: [],
      //Ürün Maliyet Listesi
      costReportOfStockList: [],
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ////////CustomerPayment DEĞİŞKENLER
      chartOptionsConsolidatedCustomerPayment: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedCustomerPaymentWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],
      customerPaymentConsolidatedTLList: [],
      /////////END CustomerPayment DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////

      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ////////EXPENSE DEĞİŞKENLER
      chartOptionsConsolidatedExpense: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedExpenseWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],
      expenseConsolidatedTLList: [],
      /////////END EXPENSE DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////

      // date : Date.prototype.getDate(),

      saleForRegionPersonnelList: [],

      //BRAND Değişkenler
      saleBrandConsolidatedTLList: [],
      chartOptionsConsolidatedBrand: {
        chart: {
          events: {
            dataPointSelection: (event, chartContext, config) => {
              // console.log(config.w.config.xaxis.categories[config.dataPointIndex]);
              // console.log(config.w.config.series[0].data[config.dataPointIndex]);
              this.openProductBasePopup(config.w.config.xaxis.categories[config.dataPointIndex]);
            },
          },

          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedBrandWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],

      //END BRAND DEğişlkenler

      //Product Değişkenler
      popupProductBase: false,
      selectedBrand: { brand: null, total: null },
      saleProductBaseConsolidatedTLList: [],
      chartOptionsConsolidatedProductBase: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedProductBaseWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],

      //END Product DEğişlkenler

      saleForRegionDashboardPersonnelConsoliadtedTLList: [],
      saleForOutOfRegionList: [],
      saleForRegionList: [],
      salePerformanceDayList: [],
      saleForRegionDashboardConsolidatedTLList: [],

      sumOfOwningCostTL: 0.0,
      sumOfSalePriceTL: 0.0,

      searchModel: { startDate: this.startDate, finishDate: this.finishDate, startTransactionDate: this.startDate, finishTransactionDate: this.finishDate, currencyValueUsd: null, currencyValueEuro: null, currencyValueYuan: null },

      nitroSales: {},

      chartOptions: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
      },

      series: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],

      chartOptionsConsolidatedPersonnelWatch: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedPersonnelWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],

      //region watch grafiği için
      chartOptionsConsolidatedRegionWatch: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
      },
      seriesConsolidatedRegionWatch: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],
    };
  },

  created: async function() {
    let currentDate = new Date();
    // this.searchModel.finishDate = currentDate.toISOString().substr(0, 10);
    // this.searchModel.startDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1)).toISOString().substr(0, 10);

    var date = new Date(),
      y = currentDate.getFullYear(),
      m = date.getMonth(),
      d = date.getDay();

    this.searchModel.startDate = new Date(y, m, 1, 3).toISOString().slice(0, 10); //GMT 3 ün 3 değeri

    this.searchModel.finishDate = new Date(y, m + 1, 1).toISOString().slice(0, 10);

    this.searchModel.startTransactionDate = new Date(y, m, 1, 3).toISOString().slice(0, 10); //GMT 3 ün 3 değeri
    this.searchModel.finishTransactionDate = new Date(y, m + 1, 1).toISOString().slice(0, 10);

    await this.getCurrencies();
    this.GetCases();
  },

  methods: {
    getCurrencies: async function() {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);

      this.searchModel.currencyValueUsd = this.moneyCurrencyOptions[0]["value"];
      this.searchModel.currencyValueEuro = this.moneyCurrencyOptions[1]["value"];

      this.searchModel.currencyValueYuan = this.moneyCurrencyOptions[3]["value"];
    },
    getSumOfList: function(list) {
      let sumTL = 0.0;

      list.forEach((element) => {
        sumTL += element.amountTL;
      });

      return sumTL.toFixed(2);
    },

    getSumOfBrandBaseList: async function(list) {
      this.sumOfOwningCostTL = 0.0;
      this.sumOfSalePriceTL = 0.0;
      list.forEach((element) => {
        this.sumOfOwningCostTL += element.owningCostTL;
        this.sumOfSalePriceTL += element.amountTL;
      });

      this.sumOfOwningCostTL = parseFloat(this.sumOfOwningCostTL).toFixed(2);
      this.sumOfSalePriceTL = parseFloat(this.sumOfSalePriceTL).toFixed(2);
    },

    getSumOfStockOwningCost: function(list) {
      let sumTL = 0.0;

      list.forEach((element) => {
        sumTL += element.totalOwningCostTL;
      });

      return sumTL.toFixed(2);
    },

    getSumOfStockSalePrice: function(list) {
      let sumTL = 0.0;

      list.forEach((element) => {
        sumTL += element.totalSalePriceTL;
      });

      return sumTL.toFixed(2);
    },

    GetSaleForRegionDashboardPersonnel: async function() {
      this.saleForRegionPersonnelList = await repository.postEntity("Accounting/GetSaleForRegionDashboardPersonnel", this.searchModel).then((r) => r.list);
    },

    GetSaleForOutOfRegionDashboard: async function() {
      this.saleForOutOfRegionList = await repository.postEntity("Accounting/GetSaleForOutOfRegionDashboard", this.searchModel).then((r) => r.list);
    },

    GetSaleForRegionDashboard: async function() {
      this.saleForRegionList = await repository.postEntity("Accounting/GetSaleForRegionDashboard", this.searchModel).then((r) => r.list);
    },

    GetSaleForRegionDashboardConsolidatedTL: async function() {
      this.searchModel.searchType = "Sale";
      this.searchModel.displayType = "GrouppedCustomerRegionSale";
      this.saleForRegionDashboardConsolidatedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);
      this.GetSaleConsolidatedRegionWatchForChart();
    },

    //Bölge bazlı satış grafiği
    GetSaleConsolidatedRegionWatchForChart: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.saleForRegionDashboardConsolidatedTLList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedRegionWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedRegionWatch = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    GetSaleForRegionDashboardPersonnelConsoliadtedTL: async function() {
      // this.saleForRegionDashboardPersonnelConsoliadtedTLList = await repository.postEntity("Accounting/GetSaleForRegionDashboardPersonnelConsoliadtedTL", this.searchModel).then((r) => r.list);

      this.searchModel.searchType = "Sale";
      this.searchModel.displayType = "GrouppedPersonnelSale";
      this.saleForRegionDashboardPersonnelConsoliadtedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);
      this.GetSaleConsolidatedPersonnelWatch();
    },

    //NİTRO GÜN BAZLI SATIŞ GRAFİĞİ
    GetSalePerformanceDay: async function() {
      this.salePerformanceDayList = await repository.postEntity("Accounting/GetSalePerformanceDay", this.searchModel).then((r) => r.list);

      let xAxisList = [];
      let yAxisList = [];

      this.salePerformanceDayList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.date.substr(0, 10));
        yAxisList.push(row.amount);
      });

      this.series = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptions = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    GetSaleConsolidatedPersonnelWatch: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.saleForRegionDashboardPersonnelConsoliadtedTLList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedPersonnelWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedPersonnelWatch = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    ////////////////////////////////////////////////////////////////
    ////////////////BRAND///////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetSaleBrandConsolidatedTLList: async function() {
      this.searchModel.searchType = "Sale";
      this.searchModel.displayType = "GrouppedBrandSale";
      this.saleBrandConsolidatedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);

      this.getSumOfBrandBaseList(this.saleBrandConsolidatedTLList);
      this.GetSaleBrandConsolidatedTLForChart();
    },

    //Marka bazlı satış grafiği
    GetSaleBrandConsolidatedTLForChart: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.saleBrandConsolidatedTLList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedBrandWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedBrand = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    openProductBasePopup: async function(brandName) {
      this.popupProductBase = true;
      this.searchModel.brand = brandName;
      this.selectedBrand.brand = brandName;
      this.$vs.loading();
      await this.GetProductBaseConsolidatedTLList();
      this.$vs.loading.close();
    },

    ////////////////////////////////////////////////////////////////
    ////////////////BRAND END///////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////
    ////////////////ProductBase///////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetProductBaseConsolidatedTLList: async function() {
      this.searchModel.searchType = "Sale";
      this.searchModel.displayType = "GrouppedProductBase";
      this.saleProductBaseConsolidatedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);

      this.GetSaleProductBaseConsolidatedTLForChart();
    },

    //ProductBase bazlı satış grafiği
    GetSaleProductBaseConsolidatedTLForChart: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.saleProductBaseConsolidatedTLList.forEach((row) => {
        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedProductBaseWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedProductBase = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
      this.chartOptionsConsolidatedProductBase.plotOptions = {
        bar: {
          borderRadius: 4,
          horizontal: true,
        },
      };
    },

    ////////////////////////////////////////////////////////////////
    ////////////////ProductBase END///////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////
    ////////////////EXPENSE/////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetExpenseConsolidatedTLList: async function() {
      this.searchModel.searchType = "Expense";
      this.searchModel.displayType = "GrouppedExpense";
      this.expenseConsolidatedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);
      this.GetExpenseConsolidatedTLForChart();
    },

    //Marka bazlı satış grafiği
    GetExpenseConsolidatedTLForChart: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.expenseConsolidatedTLList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedExpenseWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedExpense = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    ////////////////////////////////////////////////////////////////
    ////////////////EXPENSE END/////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////
    ////////////////CustomerPayment/////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetCustomerPaymentConsolidatedTLList: async function() {
      this.searchModel.searchType = "CustomerPayment";
      this.searchModel.displayType = "GrouppedCustomerPayment";
      this.customerPaymentConsolidatedTLList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);
      this.GetCustomerPaymentConsolidatedTLForChart();
    },

    //Marka bazlı satış grafiği
    GetCustomerPaymentConsolidatedTLForChart: async function() {
      let xAxisList = [];
      let yAxisList = [];

      this.customerPaymentConsolidatedTLList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.accountDescription);
        yAxisList.push(row.amountTL);
      });

      this.seriesConsolidatedCustomerPaymentWatch = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptionsConsolidatedCustomerPayment = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    ////////////////////////////////////////////////////////////////
    ////////////////CustomerPayment END/////////////////////////////
    ////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////
    ////////////////CustomerPayment/////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetCostReportOfStock: async function() {
      this.costReportOfStockList = await repository.postEntity("Accounting/GetCostReportOfStock", this.searchModel).then((r) => r.list);
    },

    ////////////////////////////////////////////////////////////////
    ////////////////CustomerPayment END/////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetCases: async function() {
      this.$vs.loading();
      await Promise.all([
        this.GetSaleForRegionDashboardPersonnelConsoliadtedTL(),
        this.GetSaleForRegionDashboardConsolidatedTL(),
        this.GetSaleBrandConsolidatedTLList(),
        this.GetExpenseConsolidatedTLList(),
        this.GetCustomerPaymentConsolidatedTLList(),
        this.GetCostReportOfStock(),
      ]);
      this.$vs.loading.close();
    },
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.popupProductBase = false;
      }
    });
  },
};
</script>
